

















































































































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  toRef,
} from '@nuxtjs/composition-api'
import { FormRef } from '../base/Form.vue'
import { CustomRules, useValidations } from '~/composables/ui/useValidations'
import { useAuth } from '~/composables/useAuth'
import { useLanguage } from '~/composables/useLanguage'
import { useConfig } from '~/composables/useConfig'

export default defineComponent({
  name: 'FormRegister',

  setup() {
    const { config } = useConfig()

    const isOptInNewCustomersByDefault = computed(
      () => config.value?.loyaltyCard?.optInNewCustomersByDefault ?? false
    )

    const { languageCodeOptions, currentLocale } = useLanguage()

    const formEl = ref<FormRef | null>(null)
    const form = reactive({
      gender: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      languageCode: currentLocale.value,
      isOptIn: false,
      isLoyaltyCustomer: false,
      acceptTermsConditions: false,
    })

    const {
      validators: { confirmPassword },
    } = useValidations()

    const rules: CustomRules<typeof form> = {
      gender: ['required'],
      firstName: ['required'],
      lastName: ['required'],
      email: ['required', 'email', 'checkEmail'],
      password: ['required', 'password'],
      confirmPassword: [
        'required',
        {
          name: 'confirmPassword',
          // form.password is not work here, should be wrap as a ref
          validator: confirmPassword(toRef(form, 'password')),
        },
      ],
    }

    const { register, registerLoading } = useAuth()
    const registerFailMessage = ref('')
    const isRegisterFail = ref(false)

    const onSubmit = async () => {
      if (!formEl.value) return
      const valid = await formEl.value.validate()
      if (!valid) return

      // OptInNewCustomersByDefault is true, the user should always receive a loyaltycard.
      if (isOptInNewCustomersByDefault.value) {
        form.isLoyaltyCustomer = true
      }
      const response = await register(form)
      registerFailMessage.value = response?.message ?? ''
      isRegisterFail.value = !!registerFailMessage.value
    }

    return {
      formEl,
      form,
      rules,
      languageCodeOptions,
      registerLoading,
      registerFailMessage,
      isRegisterFail,
      isOptInNewCustomersByDefault,

      onSubmit,
    }
  },
})
